/* tslint:disable */
/* eslint-disable */
/**
 * WSK APIドキュメント
 *  WSK APIドキュメント  ## レスポンス形式 - result     - **status**：     - **message**：     - **system_date**：     - **pageno**： - data     - list         - **datacount**：         - **maxcount**：         - **list**：   ### result.status - **success**：正常終了 - **error**：入力エラー、権限エラー - **warning**：警告で、通知する必要のあるメッセージがある - **info**：正常処理で、通知する必要のあるメッセージがある  
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MstSupplier
 */
export interface MstSupplier {
    /**
     * 
     * @type {boolean}
     * @memberof MstSupplier
     */
    deleteFlg: boolean | null;
    /**
     * 
     * @type {Date}
     * @memberof MstSupplier
     */
    insertDatetime: Date | null;
    /**
     * 
     * @type {string}
     * @memberof MstSupplier
     */
    insertUser: string | null;
    /**
     * 
     * @type {Date}
     * @memberof MstSupplier
     */
    updateDatetime: Date | null;
    /**
     * 
     * @type {string}
     * @memberof MstSupplier
     */
    updateUser: string | null;
    /**
     * 
     * @type {Date}
     * @memberof MstSupplier
     */
    deleteDatetime: Date | null;
    /**
     * 
     * @type {string}
     * @memberof MstSupplier
     */
    deleteUser: string | null;
    /**
     * 
     * @type {number}
     * @memberof MstSupplier
     */
    companyId: number | null;
    /**
     * 
     * @type {string}
     * @memberof MstSupplier
     */
    orgSupplierId: string | null;
    /**
     * 
     * @type {number}
     * @memberof MstSupplier
     */
    supplierCompanyId: number | null;
    /**
     * 
     * @type {string}
     * @memberof MstSupplier
     */
    supplierName: string | null;
    /**
     * 
     * @type {string}
     * @memberof MstSupplier
     */
    transportOrgCenterId: string | null;
    /**
     * 
     * @type {string}
     * @memberof MstSupplier
     */
    supplierHojinNo: string | null;
    /**
     * 
     * @type {string}
     * @memberof MstSupplier
     */
    supplierAddress: string | null;
    /**
     * 
     * @type {string}
     * @memberof MstSupplier
     */
    supplierGln: string | null;
    /**
     * 
     * @type {number}
     * @memberof MstSupplier
     */
    minOrderQuantityOnce: number | null;
    /**
     * 
     * @type {number}
     * @memberof MstSupplier
     */
    orderLeadtime: number | null;
    /**
     * 
     * @type {string}
     * @memberof MstSupplier
     */
    orderLimitTime: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof MstSupplier
     */
    enableShipdayMon: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof MstSupplier
     */
    enableShipdayTue: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof MstSupplier
     */
    enableShipdayWed: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof MstSupplier
     */
    enableShipdayThu: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof MstSupplier
     */
    enableShipdayFri: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof MstSupplier
     */
    enableShipdaySat: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof MstSupplier
     */
    enableShipdaySun: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof MstSupplier
     */
    enableOrderdayMon: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof MstSupplier
     */
    enableOrderdayTue: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof MstSupplier
     */
    enableOrderdayWed: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof MstSupplier
     */
    enableOrderdayThu: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof MstSupplier
     */
    enableOrderdayFri: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof MstSupplier
     */
    enableOrderdaySat: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof MstSupplier
     */
    enableOrderdaySun: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof MstSupplier
     */
    orderTiming: string | null;
    /**
     * 
     * @type {string}
     * @memberof MstSupplier
     */
    monthlyOrderLimitDay: string | null;
    /**
     * 
     * @type {string}
     * @memberof MstSupplier
     */
    monthlyOrderTarget: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof MstSupplier
     */
    enableSupplierShipday: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof MstSupplier
     */
    remarks: string | null;
}

/**
 * Check if a given object implements the MstSupplier interface.
 */
export function instanceOfMstSupplier(value: object): value is MstSupplier {
    if (!('deleteFlg' in value) || value['deleteFlg'] === undefined) return false;
    if (!('insertDatetime' in value) || value['insertDatetime'] === undefined) return false;
    if (!('insertUser' in value) || value['insertUser'] === undefined) return false;
    if (!('updateDatetime' in value) || value['updateDatetime'] === undefined) return false;
    if (!('updateUser' in value) || value['updateUser'] === undefined) return false;
    if (!('deleteDatetime' in value) || value['deleteDatetime'] === undefined) return false;
    if (!('deleteUser' in value) || value['deleteUser'] === undefined) return false;
    if (!('companyId' in value) || value['companyId'] === undefined) return false;
    if (!('orgSupplierId' in value) || value['orgSupplierId'] === undefined) return false;
    if (!('supplierCompanyId' in value) || value['supplierCompanyId'] === undefined) return false;
    if (!('supplierName' in value) || value['supplierName'] === undefined) return false;
    if (!('transportOrgCenterId' in value) || value['transportOrgCenterId'] === undefined) return false;
    if (!('supplierHojinNo' in value) || value['supplierHojinNo'] === undefined) return false;
    if (!('supplierAddress' in value) || value['supplierAddress'] === undefined) return false;
    if (!('supplierGln' in value) || value['supplierGln'] === undefined) return false;
    if (!('minOrderQuantityOnce' in value) || value['minOrderQuantityOnce'] === undefined) return false;
    if (!('orderLeadtime' in value) || value['orderLeadtime'] === undefined) return false;
    if (!('orderLimitTime' in value) || value['orderLimitTime'] === undefined) return false;
    if (!('enableShipdayMon' in value) || value['enableShipdayMon'] === undefined) return false;
    if (!('enableShipdayTue' in value) || value['enableShipdayTue'] === undefined) return false;
    if (!('enableShipdayWed' in value) || value['enableShipdayWed'] === undefined) return false;
    if (!('enableShipdayThu' in value) || value['enableShipdayThu'] === undefined) return false;
    if (!('enableShipdayFri' in value) || value['enableShipdayFri'] === undefined) return false;
    if (!('enableShipdaySat' in value) || value['enableShipdaySat'] === undefined) return false;
    if (!('enableShipdaySun' in value) || value['enableShipdaySun'] === undefined) return false;
    if (!('enableOrderdayMon' in value) || value['enableOrderdayMon'] === undefined) return false;
    if (!('enableOrderdayTue' in value) || value['enableOrderdayTue'] === undefined) return false;
    if (!('enableOrderdayWed' in value) || value['enableOrderdayWed'] === undefined) return false;
    if (!('enableOrderdayThu' in value) || value['enableOrderdayThu'] === undefined) return false;
    if (!('enableOrderdayFri' in value) || value['enableOrderdayFri'] === undefined) return false;
    if (!('enableOrderdaySat' in value) || value['enableOrderdaySat'] === undefined) return false;
    if (!('enableOrderdaySun' in value) || value['enableOrderdaySun'] === undefined) return false;
    if (!('orderTiming' in value) || value['orderTiming'] === undefined) return false;
    if (!('monthlyOrderLimitDay' in value) || value['monthlyOrderLimitDay'] === undefined) return false;
    if (!('monthlyOrderTarget' in value) || value['monthlyOrderTarget'] === undefined) return false;
    if (!('enableSupplierShipday' in value) || value['enableSupplierShipday'] === undefined) return false;
    if (!('remarks' in value) || value['remarks'] === undefined) return false;
    return true;
}

export function MstSupplierFromJSON(json: any): MstSupplier {
    return MstSupplierFromJSONTyped(json, false);
}

export function MstSupplierFromJSONTyped(json: any, ignoreDiscriminator: boolean): MstSupplier {
    if (json == null) {
        return json;
    }
    return {
        
        'deleteFlg': json['delete_flg'],
        'insertDatetime': (json['insert_datetime'] == null ? null : new Date(json['insert_datetime'])),
        'insertUser': json['insert_user'],
        'updateDatetime': (json['update_datetime'] == null ? null : new Date(json['update_datetime'])),
        'updateUser': json['update_user'],
        'deleteDatetime': (json['delete_datetime'] == null ? null : new Date(json['delete_datetime'])),
        'deleteUser': json['delete_user'],
        'companyId': json['company_id'],
        'orgSupplierId': json['org_supplier_id'],
        'supplierCompanyId': json['supplier_company_id'],
        'supplierName': json['supplier_name'],
        'transportOrgCenterId': json['transport_org_center_id'],
        'supplierHojinNo': json['supplier_hojin_no'],
        'supplierAddress': json['supplier_address'],
        'supplierGln': json['supplier_gln'],
        'minOrderQuantityOnce': json['min_order_quantity_once'],
        'orderLeadtime': json['order_leadtime'],
        'orderLimitTime': json['order_limit_time'],
        'enableShipdayMon': json['enable_shipday_mon'],
        'enableShipdayTue': json['enable_shipday_tue'],
        'enableShipdayWed': json['enable_shipday_wed'],
        'enableShipdayThu': json['enable_shipday_thu'],
        'enableShipdayFri': json['enable_shipday_fri'],
        'enableShipdaySat': json['enable_shipday_sat'],
        'enableShipdaySun': json['enable_shipday_sun'],
        'enableOrderdayMon': json['enable_orderday_mon'],
        'enableOrderdayTue': json['enable_orderday_tue'],
        'enableOrderdayWed': json['enable_orderday_wed'],
        'enableOrderdayThu': json['enable_orderday_thu'],
        'enableOrderdayFri': json['enable_orderday_fri'],
        'enableOrderdaySat': json['enable_orderday_sat'],
        'enableOrderdaySun': json['enable_orderday_sun'],
        'orderTiming': json['order_timing'],
        'monthlyOrderLimitDay': json['monthly_order_limit_day'],
        'monthlyOrderTarget': json['monthly_order_target'],
        'enableSupplierShipday': json['enable_supplier_shipday'] == null ? null : json['enable_supplier_shipday'],
        'remarks': json['remarks'],
    };
}

export function MstSupplierToJSON(json: any): MstSupplier {
    return MstSupplierToJSONTyped(json, false);
}

export function MstSupplierToJSONTyped(value?: MstSupplier | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'delete_flg': value['deleteFlg'],
        'insert_datetime': value['insertDatetime'] == null ? value['insertDatetime'] : value['insertDatetime'].toISOString(),
        'insert_user': value['insertUser'],
        'update_datetime': value['updateDatetime'] == null ? value['updateDatetime'] : value['updateDatetime'].toISOString(),
        'update_user': value['updateUser'],
        'delete_datetime': value['deleteDatetime'] == null ? value['deleteDatetime'] : value['deleteDatetime'].toISOString(),
        'delete_user': value['deleteUser'],
        'company_id': value['companyId'],
        'org_supplier_id': value['orgSupplierId'],
        'supplier_company_id': value['supplierCompanyId'],
        'supplier_name': value['supplierName'],
        'transport_org_center_id': value['transportOrgCenterId'],
        'supplier_hojin_no': value['supplierHojinNo'],
        'supplier_address': value['supplierAddress'],
        'supplier_gln': value['supplierGln'],
        'min_order_quantity_once': value['minOrderQuantityOnce'],
        'order_leadtime': value['orderLeadtime'],
        'order_limit_time': value['orderLimitTime'],
        'enable_shipday_mon': value['enableShipdayMon'],
        'enable_shipday_tue': value['enableShipdayTue'],
        'enable_shipday_wed': value['enableShipdayWed'],
        'enable_shipday_thu': value['enableShipdayThu'],
        'enable_shipday_fri': value['enableShipdayFri'],
        'enable_shipday_sat': value['enableShipdaySat'],
        'enable_shipday_sun': value['enableShipdaySun'],
        'enable_orderday_mon': value['enableOrderdayMon'],
        'enable_orderday_tue': value['enableOrderdayTue'],
        'enable_orderday_wed': value['enableOrderdayWed'],
        'enable_orderday_thu': value['enableOrderdayThu'],
        'enable_orderday_fri': value['enableOrderdayFri'],
        'enable_orderday_sat': value['enableOrderdaySat'],
        'enable_orderday_sun': value['enableOrderdaySun'],
        'order_timing': value['orderTiming'],
        'monthly_order_limit_day': value['monthlyOrderLimitDay'],
        'monthly_order_target': value['monthlyOrderTarget'],
        'enable_supplier_shipday': value['enableSupplierShipday'],
        'remarks': value['remarks'],
    };
}

